import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { subscribe } from '../lib/klayvio-subscribe'

export default component((node) => {
  document.addEventListener('DOMContentLoaded', (event) => {
    const form = $(node).find('form').el()
    const listId = document.querySelector('[name="list_id"]').value

    $(form).on('submit', function (e) {
      $(form).find('button[type="submit"]').attr('disabled', 'true')
      if (document.querySelector('[name="newsletter signup"]').checked == true) {
        e.preventDefault()
        e.stopImmediatePropagation()
        const email = $(form).find('[type="email"]').val()
        subscribe(listId, email)
          .then((res) => {
            if (res.success == false) {
              alert('Error! Email not subscribed to newsletter. Please try again later.')
            }
          })
          .finally(() => {
            $(form).find('button[type="submit"]').attr('disabled', 'false')
            e.target.submit()
          })
      }
    })
  })
})
